/**
 * Read before anything is read. The wording is provisional (M0.8c owns it,
 * M5.1 finalizes it); the acceptance and its version are stored locally.
 */
import { DISCLOSURE, DISCLOSURE_VERSION } from '../../disclosure.js'
import { useAppState } from '../../store/appState.js'
import styles from './Disclose.module.scss'

export function DisclosureText() {
  return (
    <ul className={styles.list}>
      {DISCLOSURE.map((line) => (
        <li key={line}>{line}</li>
      ))}
    </ul>
  )
}

export function Disclose() {
  const accept = useAppState((s) => s.accept)
  const runAgain = useAppState((s) => s.runAgain)
  return (
    <section className={styles.root} aria-labelledby="disclose-title">
      <h1 id="disclose-title" className={styles.title}>
        Before anything is read
      </h1>
      <DisclosureText />
      <p className={styles.note}>
        Provisional wording ({DISCLOSURE_VERSION}); the consent text of the study will replace it.
      </p>
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.primary}
          onClick={() => accept({ version: DISCLOSURE_VERSION, at: new Date().toISOString() })}
        >
          I understand — continue
        </button>
        <button type="button" className={styles.quiet} onClick={runAgain}>
          Go back
        </button>
      </div>
    </section>
  )
}
